import { render } from "./PlanLegalLinks.vue?vue&type=template&id=3e418df4&scoped=true"
import script from "./PlanLegalLinks.vue?vue&type=script&lang=js"
export * from "./PlanLegalLinks.vue?vue&type=script&lang=js"

import "./PlanLegalLinks.vue?vue&type=style&index=0&id=3e418df4&scoped=true&lang=css"

import exportComponent from "C:\\Users\\darca\\dev\\spanish-ai\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e418df4"]])

export default __exports__